<section class="section white-100" *ngIf="caseOtherFeatureData">
  <div [class.section-container-inside]="!isInside"
    [class.section-container]="isInside">
    <h2 class="section-heading mar-b-32">
      {{ caseOtherFeatureData?.title }}
    </h2>
    <div class="section-explore-more">
        <ng-container *ngFor="let item of caseOtherFeatureData?.component1">
          <div class="explore-more">
            <div class="product-landing-content">
              <h5 class="explore-more-heading">
                {{ item?.fields?.title }}
                <img
                  loading="lazy"
                  class="mar-l-8"
                  src="{{ item?.fields?.iconImage?.fields?.file?.url }}"
                  alt=""
                />
              </h5>
              <p class="product-landing-description">
                {{ item?.fields?.description?.content[0]?.content[0]?.value }}
              </p>
            </div>
            <figure>
              <img
                loading="lazy"
                src="{{ item?.fields?.imageicon?.fields?.file?.url }}"
                alt="{{ item?.fields?.imageicon?.fields?.title }}"
                class="product-landing-img"
              />
            </figure>
            <a class="explore-more-link" [href]="item?.fields?.link | urlParams:queryParams"
               (click)="onCardClick(item?.fields?.title, item?.fields?.link)"></a>
          </div>
        </ng-container>
      </div>
  </div>
</section>
